import type { ReportComponentProps } from "@qendo/profile/reports";
import { useMemo } from "react";
import { Report } from "~/components/layout/reports/Report";
import { formatShortMonthName } from "~/util/dates";

export const AnnualReport = ({ report, data, ...reportProps }: ReportComponentProps) => {
    const labels = useMemo(() => data.points.map(({ date }) => formatShortMonthName(date)), [data.points]);

    return (
        <Report
            {...reportProps}
            labels={labels}
            report={report}
            data={data}
            initialSpacing={3}
            endSpacing={3}
            rotateLabel
        />
    );
};
